export function AdminNav({ groups, value, onChange }) {
  return (
    <nav data-testid="admin-nav" className="md:w-56 md:shrink-0 md:sticky md:top-20 md:self-start">
      <div className="flex md:flex-col gap-1 overflow-x-auto no-scrollbar pb-2 md:pb-0">
        {groups.map((g) => (
          <div key={g.label} className="flex md:flex-col gap-1 md:mb-4 shrink-0">
            <p className="hidden md:block px-3 mb-1 text-[10px] font-mono uppercase tracking-[0.2em] text-[#64748B]">{g.label}</p>
            {g.tabs.map((t) => {
              const active = t.id === value;
              return (
                <button
                  key={t.id}
                  type="button"
                  data-testid={`admin-tab-item-${t.id}`}
                  onClick={() => onChange(t.id)}
                  className={`shrink-0 flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${active ? "bg-[#0066FF] text-white" : "text-[#94A3B8] hover:text-white hover:bg-white/[0.06]"}`}
                >
                  <t.icon size={16} className={active ? "text-white" : "text-[#64748B]"} /> {t.label}
                </button>
              );
            })}
          </div>
        ))}
      </div>
    </nav>
  );
}
